import { LinkTag, MetaTag, TitleTag, useHelmet } from '@thd-nucleus/thd-helmet';

const metadataHandler = ({ props }) => {
  return [
    new TitleTag(props.title),
    new MetaTag({ name: 'description', content: props.description, id: 'description' }),
    new LinkTag({ rel: 'canonical', href: props.canonical, id: 'canonical' })
  ];
};

const PREFERENCE_METADATA = {
  title: 'The Home Depot',
  description: 'View and manage your preferences to tell us how you like to receive marketing communications. '
    + 'Sign up for various programs to receive savings and project ideas.',
  canonical: 'https://www.homedepot.com/myaccount/preferences'
};

export function setupHelmet() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useHelmet('preferencesMetadata', {
    props: PREFERENCE_METADATA
  }, metadataHandler, [PREFERENCE_METADATA.title, PREFERENCE_METADATA.description, PREFERENCE_METADATA.canonical]);
}
